
export default {
    install(Vue) {
        //全局过滤器
        Vue.filter('dateFormat', function (dateStr, time) {
          //得到特定的时间p
          
            var date = new Date(dateStr.replace(/-/g, "/"));
            var year = date.getFullYear();
            //ES6语法填充：var month = (date.getMonth()+1).toString().padStart(2, '0');
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

            //return `${year}-${month}-${day}`;

            if (time && time.toLowerCase() === 'yyyy-mm-dd') {
                return `${year}-${month}-${day}`;
            } else if (time && time.toLowerCase() === 'hh:mm:ss') {
                return `${hh}:${mm}:${ss}`;
            }else if (time && time.toLowerCase() === 'yyyy.mm.dd') {
                return `${year}.${month}.${day}`;
            } else if (time && time.toLowerCase() === 'yyyy/mm/dd') {
              return `${year}/${month}/${day}`;
            }
            else {
                return `${year}.${month}.${day} ${hh}:${mm}:${ss}`;
            }
        });

        Vue.filter('dateDiff', function (dateStr) {
            let dateTime = new Date(dateStr+' 24:00:00');
            let nowTime = new Date();
            let diff = parseInt(dateTime.valueOf() - nowTime.valueOf())
            let hour = parseInt(diff/1000/3600)
            let minute = parseInt((diff-hour*1000*3600)/1000/60)
            let second = parseInt((diff-minute*1000*60-hour*1000*3600)/1000)
            
            if(hour>24){
                return parseInt(hour/24);
            }else if(hour>0){
                return hour+","+minute+","+second
            }else{
                return 0
            }  
        });
        Vue.filter('dateHour', function (dateStr) {
            if(typeof dateStr != 'number'){
                let arr = dateStr.split(",")
                return arr[0]
            }else{
                return dateStr
            }
            
        });
        Vue.filter('dateMinute', function (dateStr) {
            if(typeof dateStr != 'number'){
                let arr = dateStr.split(",")
                return arr[1]
            }else{
                return dateStr
            }
            
        });
        Vue.filter('dateSecond', function (dateStr) {
            if(typeof dateStr != 'number'){
                let arr = dateStr.split(",")
                return arr[2]
            }else{
                return dateStr
            }
            
        });
        // 自定义指令
        Vue.directive(
            // 使用局部注册指令的方式
            'resize', { // 指令的名称
            bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
                let width = '', height = '';
                function isReize() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (width !== style.width || height !== style.height) {
                        binding.value();  // 关键
                    }
                    width = style.width;
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReize, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }

        )


    }
}